export default __webpack_public_path__ + "static/media/ray.a3c8f4da.jpg";